<template>

    <v-bottom-sheet v-model="sheet" :inset="!mobile">
        <!-- <v-bottom-sheet v-model="sheet" :inset="!mobile" :attach="'#the_map'"> -->
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" icon="mdi-cog" size="small" class="my-3" :color="settingColor"
                v-if="runtimeStore.session.settings.showLocalSettingsBtn" />
        </template>

        <template v-slot:default="{ isActive }">

            <v-card theme="dark" class="pa-5 pb-0">

                <div class="fluid-column">


                    <div>

                        <v-card-item>
                            <v-card-title class="text-headline-small">Acquisizione</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-dialog width="auto" style="max-height: 90vh">
                                <template v-slot:activator="{ props }">
                                    <v-btn v-bind="props" size="" id="btn-filter-gathering-types" variant="outlined"
                                        class=" pa-3" color="">
                                        <v-icon size="x-large" color="primary" class="">mdi-filter</v-icon>
                                    </v-btn>
                                    <v-label class="ml-4 text-wrap" for="btn-filter-gathering-types">
                                        Tipi in acquisizione
                                    </v-label>
                                </template>
                                <template v-slot:default="{ isActive }">
                                    <v-card theme="dark">
                                        <v-card-item class="position-sticky bg-grey-darken-4 top-0"
                                            style='z-index:20001;'>
                                            <v-card-title>Acquisizione</v-card-title>
                                        </v-card-item>

                                        <v-card-text class="">
                                            <div v-for="(possibilita, i) in dataStore.ventaglio_possibili" :key="i"
                                                :style="{ borderBottom: '5px solid ' + possibilita?.color }"
                                                class="mb-5">
                                                <v-checkbox density="compact" hide-details color="success"
                                                    v-model="runtimeStore.session.settings.showInsertType[possibilita.id]"
                                                    @update:model-value="runtimeStore.saveSession">
                                                    <template v-slot:label>
                                                        <span
                                                            :class="runtimeStore.session.settings.showInsertType[possibilita.id] ? 'text-white' : 'text-grey'">
                                                            {{ possibilita.descrizione }}
                                                        </span>
                                                    </template>
                                                </v-checkbox>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions
                                            class="d-flex align-center position-sticky bg-grey-darken-4 bottom-0">
                                            <v-btn variant="outlined" size="large" color="white"
                                                @click="isActive.value = false">
                                                <v-icon>mdi-chevron-down</v-icon>
                                                Indietro</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>


                        </v-card-text>
                    </div>


                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Etichette</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-switch v-model="runtimeStore.session.settings.showMapLabels" hide-details
                                color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div><v-btn class="ml-3 mr-1 disable-events" color="yellow-darken-2" size="x-small"
                                            icon="mdi-text-short" />
                                        Mostra (a zoom alto) 
                                    <!-- resolution > 9.4, ovvero zoom 14 -->
                                    </div>
                                </template>
                            </v-switch>
                        </v-card-text>
                    </div>




                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Bottoni</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-switch v-model="runtimeStore.session.settings.showInfoPosition" hide-details
                                color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div><v-btn class="ml-3 mr-1 disable-events" color="blue" size="x-small"
                                            icon="mdi-information-outline" />
                                        Informazioni</div>
                                </template>
                            </v-switch>

                            <v-switch v-model="runtimeStore.session.settings.showTeleporter" hide-details
                                color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div>
                                        <v-btn class="ml-3 mr-1 disable-events" color="pink-darken-2" dark
                                            size="x-small" icon="mdi-arrow-right" />

                                        Spostamento
                                    </div>
                                </template>
                            </v-switch>

                            <v-switch v-model="runtimeStore.session.settings.showQuickAddMedia" hide-details
                                color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div>
                                        <v-btn class="ml-3 mr-1 disable-events" color="deep-orange-darken-3" dark
                                            size="x-small" icon="mdi-plus" />
                                        Acquisizione Rapida
                                    </div>
                                </template>
                            </v-switch>

                            <v-switch label="Zoom + / -" v-model="runtimeStore.session.settings.showZoomControl"
                                hide-details color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div><v-btn class="ml-3 mr-1 disable-events" color="grey-lighten-3"
                                            variant="outlined" size="x-small" icon="mdi-plus-minus" />
                                        Zoom</div>
                                </template>
                            </v-switch>
                        </v-card-text>
                    </div>




                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Freccia posizione</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <arrow-settings v-model:color="runtimeStore.session.settings.arrowColor"
                                @update:color="runtimeStore.saveSession" />
                            <!-- <p class="mt-5">Lingua</p>
<v-select @update:menu="updateLang" v-model="$i18n.locale" :items="languages" class="mt-4"></v-select> -->
                        </v-card-text>
                    </div>


                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Stile punti</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-btn @click="setPointStyle('circle')"
                                :variant="runtimeStore.session.settings.pointStyle === 'circle' ? 'flat' : 'outlined'"
                                :color="runtimeStore.session.settings.pointStyle === 'circle' ? 'primary' : 'grey'"
                                size="" class="pa-4 mr-4">
                                <v-icon size="x-large">mdi-circle-outline</v-icon>
                            </v-btn>
                            <v-btn @click="setPointStyle('marker')"
                                :variant="runtimeStore.session.settings.pointStyle === 'marker' ? 'flat' : 'outlined'"
                                :color="runtimeStore.session.settings.pointStyle === 'marker' ? 'primary' : 'grey'"
                                size="" class="pa-4 mr-4">
                                <v-icon size="x-large">mdi-map-marker</v-icon>
                            </v-btn>
                        </v-card-text>
                    </div>


                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Croce centro mappa</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <cross-settings v-model:color="runtimeStore.session.settings.crossColor"
                                v-model:width="runtimeStore.session.settings.crossWidth"
                                @update:color="runtimeStore.saveSession" @update:width="runtimeStore.saveSession" />
                            <!-- <p class="mt-5">Lingua</p>
<v-select @update:menu="updateLang" v-model="$i18n.locale" :items="languages" class="mt-4"></v-select> -->
                        </v-card-text>
                    </div>

                    <div>
                        <v-card-item>
                            <v-card-title class="text-headline-small">Mano prevalente</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-btn-toggle v-model="runtimeStore.session.settings.hand" @update:modelValue="updateHand"
                                mandatory>
                                <v-btn :border="true" variant="flat" value="left">sinistra
                                    <span v-if="runtimeStore.session.settings.hand === 'left'" class="ml-3 mr-1">
                                        🤚 📱
                                    </span>
                                </v-btn>
                                <v-btn :border="true" variant="flat" value="right">
                                    <span v-if="runtimeStore.session.settings.hand === 'right'" class="ml-1 mr-3">
                                        📱✋
                                    </span>
                                    destra
                                </v-btn>
                            </v-btn-toggle>
                            <p class="mt-4 text-grey">Riflette i comandi dalla mappa</p>
                        </v-card-text>
                    </div>



                    <div v-if="runtimeStore.session.user?.pk == 63">
                        <v-card-item>
                            <v-card-title class="text-headline-small">Confini mappa (user__pk==63)</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-switch label="Extent" v-model="runtimeStore.session.settings.mapExtentLocked"
                                hide-details color="success" @update:model-value="runtimeStore.saveSession" inset>
                                <template v-slot:label>
                                    <div>Bloccati</div>
                                </template>
                            </v-switch>
                        </v-card-text>
                    </div>



                    <div v-if="runtimeStore.session.user?.pk == 699">
                        <v-card-item>
                            <v-card-title class="text-headline-small">Proiezione (user__pk==63)</v-card-title>
                        </v-card-item>
                        <v-card-text>
                            <v-radio-group v-model="runtimeStore.session.settings.viewProjection"
                                @update:model-value="projectionUpdated">
                                <v-radio value="EPSG:3857">
                                    <template v-slot:label>
                                        <div>EPSG:3857</div>
                                    </template>
                                </v-radio>
                                <v-radio value="EPSG:32632">
                                    <template v-slot:label>
                                        <div>EPSG:32632</div>
                                    </template>
                                </v-radio>
                                <v-radio value="EPSG:23032">
                                    <template v-slot:label>
                                        <div>EPSG:23032</div>
                                    </template>
                                </v-radio>
                                <v-radio value="EPSG:4326">
                                    <template v-slot:label>
                                        <div>EPSG:4326</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-card-text>
                    </div>



                </div>
                <v-card-actions>
                    <v-btn size="large" class="my-2" variant="outlined" color="white" @click="isActive.value = false">
                        <v-icon>mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>



            </v-card>
        </template>
    </v-bottom-sheet>
</template>



<script setup>

import { ref, computed } from "vue";
import { useRuntimeStore } from "@/store/runtime"
import CrossSettings from "@/components/map/CrossSettings";
import ArrowSettings from "@/components/map/ArrowSettings";

import { useDataStore } from "@/store/data";
const dataStore = useDataStore();

import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()




const emit = defineEmits(['onChangeProjection'])

const projectionUpdated = (model) => {
    runtimeStore.saveSession()
    emit('onChangeProjection', model)
}


const runtimeStore = useRuntimeStore();

const sheet = ref(false)
const settingMode = ref(false)
const settingColor = computed(() => {
    return settingMode.value ? "red-darken-4" : "blue-grey-darken-4"
})


const updateHand = () => {
    runtimeStore.saveSession()
}

const setPointStyle = (style) => {
    runtimeStore.session.settings.pointStyle = style
    runtimeStore.saveSession()
}
// const updateLang = () => {
//   console.log(locale.value)
//   runtimeStore.session.settings.lang = locale.value
//   runtimeStore.saveSession()
// }

</script>

<style scoped>
.v-btn {
    pointer-events: auto;
}


.disable-events {
    pointer-events: none;
    opacity: .8;
}




.v-card-actions {
    background: rgb(33, 33, 33);
    width: 100%;
    justify-content: center !important;
    align-items: center;
    position: sticky;
    bottom: 0;
    z-index: 1006;
    margin: 0 !important;
}
</style>
